import { useEffect } from 'react';

/**
 * Хук для применения темы виджета через CSS переменные
 */
export const useWidgetTheme = (theme) => {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--widget-primary-color', theme.primaryColor);
    root.style.setProperty('--widget-background-color', theme.backgroundColor);
    root.style.setProperty('--widget-text-color', theme.textColor);
    root.style.setProperty('--widget-button-text-color', theme.buttonTextColor);
    root.style.setProperty('--widget-border-radius', theme.borderRadius);
  }, [theme]);
};

